import React, { useEffect } from 'react'
import { render } from 'react-dom'
import { BrowserRouter, Route, Switch } from 'react-router-dom'
import { hot } from 'react-hot-loader/root'
import styled, { css } from 'styled-components'
import Cookies from 'js-cookie'

import ThemeProvider from 'styles/ThemeProvider'
import { COLORS } from 'shared/scss'

import CommunityAgreement from './CommunityAgreement'
import ConditionsForContributors from './ConditionsForContributors'
import Privacy from './Privacy'
import Terms from './Terms'

/*
  For now, this app is only used for community agreement.
  Later, we will move all the static pages like "about", etc
  here and fully separate frontend app from backend api.
*/

const App = () => (
  <BrowserRouter>
    <ThemeProvider>
      <Routes />
    </ThemeProvider>
  </BrowserRouter>
)

const _Routes = () => {
  const cookieData = Cookies.get()
  const locale = cookieData?.locale ? cookieData.locale : I18n.locale

  return (
    <Container>
      <Switch>
        <Route
          exact
          path="/community-agreement"
          render={() => <CommunityAgreement locale={locale} />}
        />
        <Route
          exact
          path="/conditions-for-contributors"
          render={() => <ConditionsForContributors locale={locale} />}
        />
        <Route
          exact
          path="/privacy"
          render={() => <Privacy locale={locale} />}
        />
        <Route exact path="/terms" render={() => <Terms locale={locale} />} />
        <Route path="*" component={NotFound} />
      </Switch>
    </Container>
  )
}
const Routes = hot(_Routes)

document.addEventListener('DOMContentLoaded', () => {
  render(<App />, document.getElementById('public'))
})

function NotFound() {
  useEffect(() => {
    document.location.href = ''
  }, [])
  return <div>{I18n.t('js.global.page_not_found')}</div>
}

const Container = styled.div`
  ${({ theme }) => {
    return css`
      max-width: 1100px;
      margin: 48px auto;
      padding: ${theme.formFactors.isMobile ? '0 16px' : '0 32px'};

      & > * + * {
        margin-top: 32px;
      }

      & > div.paragraph-2 {
        color: ${COLORS.neutral600};

        & > * + * {
          margin-top: 16px;
        }
      }

      div.definition {
        display: flex;
        flex-direction: ${theme.formFactors.isMobile ? 'column' : 'row'};
        width: 100%;

        p:first-child {
          color: ${COLORS.neutral900};
          width: ${theme.formFactors.isMobile ? '100%' : '25%'};
        }

        p:last-child {
          width: ${theme.formFactors.isMobile ? '100%' : '75%'};
        }
      }

      p,
      li {
        text-align: justify;

        &.heading-1 {
          text-align: center;
          font-family: ${theme.global.fontFamilyRegular};
          color: ${COLORS.neutral900};
        }
      }

      ul {
        display: block;
        padding-left: revert;
        margin-left: revert;

        & > * + * {
          margin-top: 16px;
        }

        li {
          list-style: disc outside;
          display: list-item;

          & > ul {
            margin-top: 16px;
          }
        }
      }

      table {
        border: 1px solid ${COLORS.neutral300};

        p,
        li {
          text-align: left;
        }

        td {
          border: 1px solid ${COLORS.neutral300};
          padding: 10px !important;
        }
      }
    `
  }}
`
